// Copyright (c) 2017 Deere & Company

import DealerHierarchyFacet from '../../shared/state/dealer-hierarchy-facet';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateWipFacets = (state, action) =>
    DealerHierarchyFacet.update(state, {
        $set: action.facets
    });

export default (state = getDefaultState().dealerHierarchyFacet, action) => {

    const actionTypes = {
        [actions.UPDATE_TCSM_AUDIT_DEALER_HIERARCHY_FACET]: updateWipFacets
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/audits/reducers/dealer-hierarchy-facet.js